import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import {ErrorBoundary as ReactErrorBoundary} from 'react-error-boundary';
import {ErrorBoundaryFallbackContainer} from '@Components/error-boundary-fallback-container/error-boundary-fallback-container';
import {UtmLinkBuilder} from '@Components/utm-link-builder/utm-link-builder';
import {UTM_LINK_BUILDER_CONTAINER_ID, UTM_TEMPLATE_TILES_DATA_ATTRIBUTE} from '@Components/utm-link-builder/utm-link-builder.types';
import {readUtmLinkVideoSources} from '@Components/utm-link-builder/utm-link-builder.library';
import {parseDesignTiles} from '@Components/qr-code-generator/qr-code-generator.library';
import {whenTranslationsReady} from '@Utils/translations-ready.util';

const container = document.getElementById(UTM_LINK_BUILDER_CONTAINER_ID);

const onToolError = (error: Error): void => {
  window.PMW.log('The UTM link builder stopped rendering', error);
};

const onFallbackReload = (): void => {
  window.location.reload();
};

if (container) {
  const mountPoint = container;
  whenTranslationsReady((): void => {
    createRoot(mountPoint).render(
      <StrictMode>
        <ReactErrorBoundary fallback={<ErrorBoundaryFallbackContainer onReload={onFallbackReload} />} onError={onToolError}>
          <UtmLinkBuilder
            videoSources={readUtmLinkVideoSources(mountPoint.dataset)}
            templateTiles={parseDesignTiles(mountPoint.dataset[UTM_TEMPLATE_TILES_DATA_ATTRIBUTE])}
          />
        </ReactErrorBoundary>
      </StrictMode>
    );
  });
}
